import React, { useState, useEffect } from 'react';
import styles from './index.less?modules';
import { Box, Button } from '@material-ui/core';
// import DoneIcon from '@material-ui/icons/Done';
import CloseIcon from '@material-ui/icons/Close';
import { history } from 'umi';
import { useSelector, useDispatch } from 'dva';
import DetailTab from './components/detail_tab/DetailTab';
const Member = (props) => {
  const {
    id,
    status = 'detail',
    memberCode,
    mobile,
    sourceOid,
  } = props.location.query;
  const dispatch = useDispatch();
  // //会员详情tab切换状态
  // const [value, setValue] = React.useState();
  // useEffect(() => {
  //   setValue(Number(tab));
  // }, [tab]);
  const [params, setParams] = useState({
    // key: status === 'edit' ? '1' : '1-1',
    key: 1,
    id: id,
    status: status,
  });
  // const [datas, setDatas] = useState({});
  // const dispatch = useDispatch();
  const memberDetail = useSelector((state) => state.ml.getMemberDetail);

  const handleClickExit = () => history.goBack();

  const onChange = (key) => {
    setParams({ ...params, key: key });
  };
  // 发起请求
  useEffect(() => {
    dispatch({
      type: 'ml/getMemberDetail',
      payload: {
        values: {
          memberID: id, //目前写死的为1，后续需要变动
          memberCode,
          mobile,
        },
      },
      callback: () => {
        // console.log('res==', res);
        // setDatas(res.data ? res.data : {});
      },
    });
  }, [dispatch, id, memberCode, mobile]);
  return (
    <div
      data-log={JSON.stringify({
        oid: 'page_offline_store_customer_management_details',
        isPage: true,
        params: {
          initUrl: window.location.origin + window.location.pathname,
          source: sourceOid,
        },
        events: ['_pv', '_pd'],
      })}
      className={styles.container}
    >
      <Box className={styles.left}>
        <DetailTab defaultActiveKey="1" datas={memberDetail} params={params} />
      </Box>
      <Box className={styles.right}>
        <DetailTab
          defaultActiveKey={params.key}
          params={{ ...params, id: memberDetail?.id }}
          // value={value}
          // setValue={setValue}
          onChange={onChange}
        />
      </Box>
      <Box className={styles.buttonGroup}>
        {/* {status !== 'detail' && ( */}
        {/* <Button
          variant="contained"
          className={styles.finish}
          // className="finish"
          type="submit"

          startIcon={
            <DoneIcon sx={{ width: '16px', height: '16px' }} />
          }
        >
          编辑
        </Button> */}
        {/* )} */}

        {/* {

              } */}
        {/* <Button variant="contained" color="secondary" className="reset">
                重置
              </Button> */}
        <Button
          variant="contained"
          color="secondary"
          className="exit"
          startIcon={<CloseIcon sx={{ width: '16px', height: '16px' }} />}
          onClick={handleClickExit}
        >
          退出
        </Button>
      </Box>
    </div>
  );
};
export default Member;
